export const stats = [
  { id: "mahasiswa", icon: "Users", value: 24, suffix: "", label: "Mahasiswa" },
  { id: "sekolah", icon: "School", value: 4, suffix: "", label: "Sekolah Mitra" },
  { id: "lokasi", icon: "MapPin", value: 1, suffix: "", label: "Kelurahan" },
  { id: "hari", icon: "CalendarDays", value: 45, suffix: "", label: "Hari Pengabdian" },
];
